import { api } from "./http-client";
import {
  ListingCategory,
  CreateListingCategoryDto,
  UpdateListingCategoryDto,
} from "../interfaces/listing-category.interface";

export const listingCategoriesService = {
  list: async (): Promise<ListingCategory[]> => {
    const res = await api.request<ListingCategory[]>({
      url: "/admin/listing-categories",
      method: "GET",
    });
    return res.data;
  },

  create: async (dto: CreateListingCategoryDto): Promise<ListingCategory> => {
    const res = await api.request<ListingCategory>({
      url: "/admin/listing-categories",
      method: "POST",
      data: dto,
    });
    return res.data;
  },

  update: async (id: string, dto: UpdateListingCategoryDto): Promise<ListingCategory> => {
    const res = await api.request<ListingCategory>({
      url: `/admin/listing-categories/${id}`,
      method: "PUT",
      data: dto,
    });
    return res.data;
  },

  remove: async (id: string): Promise<void> => {
    await api.request({
      url: `/admin/listing-categories/${id}`,
      method: "DELETE",
    });
  },
};
